export interface Payment {
    documents?: Array<Documents>;
    referenceCode?: string;
    referenceDate?: string;
    referenceStatus?: string;
    date?: Date;
    checked?: boolean;
    importRef?: string;
    countryCode?: string;
    customerCode?: string;
    userCreateCode?: string;
    userUpdateCode?: string;
    salesOrganization?: string;
}

interface Documents {
    documentCode?: string;
    importDocument?: string;
    jobSite?: string;
}
